/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react'
import CannedFishPackageReview from 'views/CannedFish/CannedFishPackageReview'
import CheesePackageReview from 'views/Cheese/CheesePackageReview'
import EggsPackageReview from 'views/Eggs/EggsPackageReview'
import CannedVegsFruitsPackageReview from 'views/FruitsAndVegs/CannedVegsFruits/CannedVegsFruitsPackageReview'
import FrozenVegsFruitsPackageReview from 'views/FruitsAndVegs/FrozenVegsFruits/FrozenVegsFruitsPackageReview'
import JuicePackageReview from 'views/Juices/JuicePackageReview'
import CannedBeansPackageReview from 'views/Legumes/CannedBeans/CannedBeansPackageReview'
import DryBeansPackageReview from 'views/Legumes/DryBeans/DryBeansPackageReview'
import PeanutButterPackageReview from 'views/Legumes/PeanutButter/PeanutButterPackageReview'
import FatReducedMilkPackageReview from 'views/Milk/FatReducedMilk/FatReducedMilkPackageReview'
import WholeMilkPackageReview from 'views/Milk/WholeMilk/WholeMilkPackageReview'
import BarleyPackageReview from 'views/WholeGrains/Barley/BarleyPackageReview'
import BreadPackageReview from 'views/WholeGrains/Bread/BreadPackageReview'
import BulgurPackageReview from 'views/WholeGrains/Bulgur/BulgurPackageReview'
import BrownRicePackageReview from 'views/WholeGrains/BrownRice/BrownRicePackageReview'
import OatsOatmealPackageReview from 'views/WholeGrains/OatsOatmeal/OatsOatmealPackageReview'
import DriedFruitsPackageReview from 'views/FruitsAndVegs/DriedFruits/DriedFruitsPackageReview'
import InfantFruitsAndVegsPackageReview from 'views/Infant/FruitsAndVegs/InfantFruitsAndVegsPackageReview'
import InfantMeatsPackageReview from 'views/Infant/Meats/InfantMeatsPackageReview'
import BSCornTortillaPackageReview from 'views/BSWholeGrains/CornTortilla/CornTortillaPackageReview'
import BSWheatTortillaPackageReview from 'views/BSWholeGrains/WheatTortilla/WheatTortillaPackageReview'
import BSWheatPastaPackageReview from 'views/BSWholeGrains/WheatPasta/WheatPastaPackageReview'
import BSWheatPastaNutritionReview from 'views/BSWholeGrains/WheatPasta/WheatPastaNutritionReview'
import PlantMilkPackageReview from 'views/BrandSpecific/PlantMilk/PlantMilkPackageReview'
import TofuPackageReview from 'views/Tofu/TofuPackageReview'
import TofuNutritionReview from 'views/Tofu/TofuNutritionReview'
import YogurtNutritionReview from 'views/Yogurt/YogurtNutritionReview'
import YogurtPackageReview from 'views/Yogurt/YogurtPackageReview'
import BSInfantMeatsPackageReview from 'views/BrandSpecific/Infant/Meats/BSInfantMeatsPackageReview'
import BSInfantCerealPackageReview from 'views/BrandSpecific/Infant/Cereal/BSInfantCerealPackageReview'
import BSInfantCerealNutritionReview from 'views/BrandSpecific/Infant/Cereal/BSInfantCerealNutritionReview'
import BSInfantFruitsAndVegsPackageReview from 'views/BrandSpecific/Infant/FruitsAndVegs/BSInfantFruitsAndVegsPackageReview'
import BreakfastCerealNutritionReview from 'views/BrandSpecific/BreakfastCereal/BreakfastCereal/BreakfastCerealNutritionReview'
import BreakfastCerealPackageReview from 'views/BrandSpecific/BreakfastCereal/BreakfastCereal/BreakfastCerealPackageReview'
import InstantOatmealNutritionReview from 'views/BrandSpecific/BreakfastCereal/InstantOatmeal/InstantOatmealNutritionReview'
import InstantOatmealPackageReview from 'views/BrandSpecific/BreakfastCereal/InstantOatmeal/InstantOatmealPackageReview'
import RFIInfantMeatsPackageReview from 'views/BrandSpecific/RFIInfant/Meats/RFIInfantMeatsPackageReview'
import RFIInfantFruitsAndVegsPackageReview from 'views/BrandSpecific/RFIInfant/FruitsAndVegs/RFIInfantFruitsAndVegsPackageReview'
import PlantYogurtNutritionReview from 'views/BrandSpecific/PlantYogurt/PlantYogurtNutritionReview'
import PlantYogurtPackageReview from 'views/BrandSpecific/PlantYogurt/PlantYogurtPackageReview'
import PlantCheeseNutritionReview from 'views/BrandSpecific/PlantCheese/PlantCheeseNutritionReview'
import PlantCheesePackageReview from 'views/BrandSpecific/PlantCheese/PlantCheesePackageReview'
import NutSeedButtersNutritionReview from 'views/BrandSpecific/NutSeedButters/NutSeedButtersNutritionReview'
import NutSeedButtersPackageReview from 'views/BrandSpecific/NutSeedButters/NutSeedButtersPackageReview'
import PlantMilkNutritionReview from 'views/BrandSpecific/PlantMilk/PlantMilkNutritionReview'
import BSWholeWheatBagelsPackageReview from 'views/BrandSpecific/WholeGrains/BSWholeWheatBagels/BSWholeWheatBagelsPackageReview'
import BSQuinoaPackageReview from 'views/BrandSpecific/WholeGrains/BSQuinoa/BSQuinoaPackageReview'
import BSWholeWheatEnglishMuffinsPackageReview from 'views/BrandSpecific/WholeGrains/BSWholeWheatEnglishMuffins/BSWholeWheatEnglishMuffinsPackageReview'
import BSWholeWheatNaanPackageReview from 'views/BrandSpecific/WholeGrains/BSWholeWheatNaan/BSWholeWheatNaanPackageReview'
import BSWholeWheatPitaBreadPackageReview from 'views/BrandSpecific/WholeGrains/BSWholeWheatPitaBread/BSWholeWheatPitaBreadPackageReview'
import BSWildRicePackageReview from 'views/BrandSpecific/WholeGrains/BSWildRice/BSWildRicePackageReview'
import BSCornMasaFlourPackageReview from 'views/BrandSpecific/WholeGrains/BSCornMasaFlour/BSCornMasaFlourPackageReview'
import BSCornmealPackageReview from 'views/BrandSpecific/WholeGrains/BSCornmeal/BSCornmealPackageReview'
import BSOatsOatmealPackageReview from 'views/BrandSpecific/WholeGrains/BSOatsOatmeal/BSOatsOatmealPackageReview'
import WWBagelsPackageReview from 'views/WWBagels/WWBagelsPackageReview'
import WWMuffinsPackageReview from 'views/WWMuffins/WWMuffinsPackageReview'
import WWPitaBreadPackageReview from 'views/WWPitaBread/WWPitaBreadPackageReview'
import CornMasaFlourPackageReview from 'views/CornMasaFlour/CornMasaFlourPackageReview'
import WGCornmealPackageReview from 'views/WGCornmeal/WGCornmealPackageReview'
import CornTortillaPackageReview from 'views/WholeGrains/CornTortilla/CornTortillaPackageReview'
import WheatTortillaPackageReview from 'views/WholeGrains/WheatTortilla/WheatTortillaPackageReview'
import WheatPastaPackageReview from 'views/WholeGrains/WheatPasta/WheatPastaPackageReview'
import WheatPastaNutritionReview from 'views/WholeGrains/WheatPasta/WheatPastaNutritionReview'
import ProductDescReview from 'views/shared/ProductDescReview'
import SubmittedProductDescReview from 'views/shared/SubmittedProductDescReview'
import PricingReview from 'views/shared/PricingReview'
import ImagesUploadReview from 'views/shared/ImagesUploadReview'
import PendingProductStatus from 'views/shared/PendingProductStatus'
import ReviewedProductStatus from 'views/shared/ReviewedProductStatus'
import Comments from 'views/shared/Comments'
import ReviewOneFollowUp from 'views/shared/ReviewOneFollowUp'
import ReviewTwoFollowUp from 'views/shared/ReviewTwoFollowUp'
import SubmitterInfo from 'views/shared/SubmitterInfo'
import SamplePackage from 'views/shared/SamplePackage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlag } from '@fortawesome/free-solid-svg-icons'

export const getNutritionInfo = (item, isDisabled) => {
  let nutritionInfo

  switch (item?.fkCategory) {
    case '00':
      switch (item?.fkSubCategory) {
        case '001':
          nutritionInfo = (
            <PlantYogurtNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        case '002':
          nutritionInfo = (
            <PlantCheeseNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        case '003':
          nutritionInfo = (
            <NutSeedButtersNutritionReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        default:
          break
      }
      break
    case '02':
      switch (item?.fkSubCategory) {
        case '004':
          nutritionInfo = (
            <TofuNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '05':
      switch (item?.fkSubCategory) {
        case '001BC':
          nutritionInfo = (
            <BreakfastCerealNutritionReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '001IO':
          nutritionInfo = (
            <InstantOatmealNutritionReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        default:
          break
      }
      break
    case '09':
      switch (item?.fkSubCategory) {
        case '001BS':
          nutritionInfo = (
            <BSInfantCerealNutritionReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        default:
          break
      }
      break
    case '16':
      switch (item?.fkSubCategory) {
        case '009':
          nutritionInfo = (
            <WheatPastaNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        case '009BS':
          nutritionInfo = (
            <BSWheatPastaNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '50':
      switch (item?.fkSubCategory) {
        case '001':
        case '002':
          nutritionInfo = (
            <YogurtNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '52':
      switch (item?.fkSubCategory) {
        case '011':
          nutritionInfo = (
            <PlantMilkNutritionReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    default:
      break
  }
  return nutritionInfo
}

export const getPackagingInfo = (item, isDisabled) => {
  let packagingInfo = <SamplePackage />

  switch (item?.fkCategory) {
    case '00':
      switch (item?.fkSubCategory) {
        case '001':
          packagingInfo = (
            <PlantYogurtPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '002':
          packagingInfo = (
            <PlantCheesePackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '003':
          packagingInfo = (
            <NutSeedButtersPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '02':
      switch (item?.fkSubCategory) {
        case '001':
          packagingInfo = (
            <CheesePackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '004':
          packagingInfo = (
            <TofuPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '03':
      packagingInfo = <EggsPackageReview item={item} isDisabled={isDisabled} />
      break
    case '05':
      switch (item?.fkSubCategory) {
        case '001BC':
          packagingInfo = (
            <BreakfastCerealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '001IO':
          packagingInfo = (
            <InstantOatmealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '06':
      switch (item?.fkSubCategory) {
        case '001':
          packagingInfo = (
            <PeanutButterPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '002':
          packagingInfo = (
            <DryBeansPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '003':
          packagingInfo = (
            <CannedBeansPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '08':
      packagingInfo = (
        <CannedFishPackageReview item={item} isDisabled={isDisabled} />
      )
      break
    case '09':
      switch (item?.fkSubCategory) {
        case '001BS':
          packagingInfo = (
            <BSInfantCerealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '12':
      switch (item?.fkSubCategory) {
        case '001':
        case '002':
        case '003':
        case '101':
        case '102':
        case '103':
          packagingInfo = (
            <InfantFruitsAndVegsPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '001BS':
        case '002BS':
        case '003BS':
        case '101BS':
        case '102BS':
        case '103BS':
          packagingInfo = (
            <BSInfantFruitsAndVegsPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '001RFI':
        case '002RFI':
        case '003RFI':
        case '101RFI':
        case '102RFI':
        case '103RFI':
          packagingInfo = (
            <RFIInfantFruitsAndVegsPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        default:
          break
      }
      break
    case '13':
      switch (item?.fkSubCategory) {
        case '001':
        case '101':
          packagingInfo = (
            <InfantMeatsPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '001BS':
        case '101BS':
          packagingInfo = (
            <BSInfantMeatsPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '001RFI':
        case '101RFI':
          packagingInfo = (
            <RFIInfantMeatsPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '16':
      switch (item?.fkSubCategory) {
        case '001':
          packagingInfo = (
            <BreadPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '003':
          packagingInfo = (
            <BrownRicePackageReview
              key={item}
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '004':
          packagingInfo = (
            <BulgurPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '005':
          packagingInfo = (
            <OatsOatmealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '005BS':
          packagingInfo = (
            <BSOatsOatmealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '006':
          packagingInfo = (
            <BarleyPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '007':
          packagingInfo = (
            <CornTortillaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '007BS':
          packagingInfo = (
            <BSCornTortillaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '008':
          packagingInfo = (
            <WheatTortillaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '008BS':
          packagingInfo = (
            <BSWheatTortillaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '009':
          packagingInfo = (
            <WheatPastaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '009BS':
          packagingInfo = (
            <BSWheatPastaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '010BS':
          packagingInfo = (
            <BSWholeWheatBagelsPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '011BS':
          packagingInfo = (
            <BSWholeWheatEnglishMuffinsPackageReview item={item} />
          )
          break
        case '012BS':
          packagingInfo = (
            <BSWholeWheatPitaBreadPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '010':
          packagingInfo = (
            <WWBagelsPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '011':
          packagingInfo = (
            <WWMuffinsPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '012':
          packagingInfo = (
            <WWPitaBreadPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '013':
          packagingInfo = (
            <BSWholeWheatNaanPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '014':
          packagingInfo = (
            <BSQuinoaPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '015':
          packagingInfo = (
            <BSWildRicePackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '016BS':
          packagingInfo = (
            <BSCornMasaFlourPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '017BS':
          packagingInfo = (
            <BSCornmealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '016':
          packagingInfo = (
            <CornMasaFlourPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '017':
          packagingInfo = (
            <WGCornmealPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '50':
      switch (item?.fkSubCategory) {
        case '001':
        case '002':
          packagingInfo = (
            <YogurtPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    case '51':
      packagingInfo = (
        <WholeMilkPackageReview item={item} isDisabled={isDisabled} />
      )
      break
    case '52':
      switch (item?.fkSubCategory) {
        case '002':
        case '004':
        case '006':
        case '012':
        case '014':
          packagingInfo = (
            <FatReducedMilkPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        case '011':
          packagingInfo = (
            <PlantMilkPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break

    case '54':
      packagingInfo = <JuicePackageReview item={item} isDisabled={isDisabled} />
      break
    case '19':
      switch (item?.fkSubCategory) {
        case '001FF':
        case '001FV':
          packagingInfo = (
            <FrozenVegsFruitsPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '001CF':
        case '001CV':
          packagingInfo = (
            <CannedVegsFruitsPackageReview
              item={item}
              isDisabled={isDisabled}
            />
          )
          break
        case '004':
          packagingInfo = (
            <DriedFruitsPackageReview item={item} isDisabled={isDisabled} />
          )
          break
        default:
          break
      }
      break
    default:
      console.log('item Error: ' + JSON.stringify(item))
  }
  return packagingInfo
}
/* react-table column headers for "Products Submitted" page */
export const submittedColumnHeaders = [
  {
    Header: 'More Info',
    accessor: 'ReviewOneFollowUp',
    Cell: props => {
      return props.original.ReviewOneFollowUp === true ? (
        <div className="text-center">
          <FontAwesomeIcon icon={faFlag} color="orange" />
        </div>
      ) : (
        ''
      )
    },
  },
  {
    Header: 'UPC',
    accessor: 'UPC',
  },
  {
    Header: 'Cat',
    accessor: 'fkCategory',
  },
  {
    Header: 'Subcat',
    accessor: 'fkSubCategory',
  },
  {
    Header: 'Submitted',
    accessor: 'SubmissionDate',
  },
  {
    Header: 'Brand',
    accessor: 'BrandName',
  },
  {
    Header: 'Product Name',
    accessor: 'ProductName',
  },
  {
    Header: 'Sub Email',
    accessor: 'conEmail',
  },
]

/* react-table column headers for "Products Pending" page */
export const pendingColumnHeaders = [
  {
    Header: 'EBT TBD',
    accessor: 'ReviewTwoFollowUp',
    Cell: props => {
      return props.original.ReviewTwoFollowUp === true ? (
        <div className="text-center">
          <FontAwesomeIcon icon={faFlag} color="green" />
        </div>
      ) : (
        ''
      )
    },
  },
  {
    Header: 'UPC',
    accessor: 'UPC',
  },
  {
    Header: 'Cat',
    accessor: 'fkCategory',
  },
  {
    Header: 'Subcat',
    accessor: 'fkSubCategory',
  },
  {
    Header: 'Submitted',
    accessor: 'SubmissionDate',
  },
  {
    Header: 'Brand',
    accessor: 'BrandName',
  },
  {
    Header: 'Product Name',
    accessor: 'ProductName',
  },
  {
    Header: 'Rev 1',
    accessor: 'ReviewOneApproved',
  },
  {
    Header: 'Rev 1 Date',
    accessor: 'ReviewOneDate',
  },
  {
    Header: 'Sub Email',
    accessor: 'conEmail',
  },
]

/* react-table column headers for "Products Reviewed" page */
export const reviewedColumnHeaders = [
  {
    Header: 'UPC',
    accessor: 'UPC',
    /* Example of conditional cell rendering*/
    /* Cell: row => {
      return <div className={row.original.fkApprovalStatus === 3 ? 'bg-success' : 'bg-danger'}>{row.original.fkApprovalStatus}</div>
    }, */
  },
  {
    Header: 'Cat',
    accessor: 'fkCategory',
  },
  {
    Header: 'Subcat',
    accessor: 'fkSubCategory',
  },
  {
    Header: 'Submitted',
    accessor: 'SubmissionDate',
  },
  {
    Header: 'Brand',
    accessor: 'BrandName',
  },
  {
    Header: 'Product Name',
    accessor: 'ProductName',
  },
  {
    Header: 'Rev 1',
    accessor: 'ReviewOneApproved',
  },
  {
    Header: 'Rev 1 Date',
    accessor: 'ReviewOneDate',
  },
  {
    Header: 'Rev 2',
    accessor: 'ReviewTwoApproved',
  },
  {
    Header: 'Rev 2 Date',
    accessor: 'ReviewTwoDate',
  },
  {
    Header: 'Sub Email',
    accessor: 'conEmail',
  },
]

export const getProductComponents = product => {
  const productDesc = <ProductDescReview item={product} />
  const pricingInfo = <PricingReview item={product} />
  const imagesUpload = <ImagesUploadReview item={product} />
  const nutritionInfo = getNutritionInfo(product)
  const packagingInfo = getPackagingInfo(product)
  return {
    productDesc,
    nutritionInfo,
    pricingInfo,
    imagesUpload,
    packagingInfo,
  }
}

export const getSubmittedProductComponents = product => {
  const productDesc = (
    <SubmittedProductDescReview item={product} isDisabled={false} />
  )
  const pricingInfo = <PricingReview item={product} />
  const nutritionInfo = getNutritionInfo(product, false)
  const packagingInfo = getPackagingInfo(product, false)
  const imagesUpload = <ImagesUploadReview item={product} />
  const submitterInfo = <SubmitterInfo item={product} />
  const comments = <Comments item={product} />
  const reviewOneFollowUp = <ReviewOneFollowUp item={product} />
  return {
    productDesc,
    pricingInfo,
    imagesUpload,
    nutritionInfo,
    packagingInfo,
    submitterInfo,
    comments,
    reviewOneFollowUp,
  }
}

export const getPendingProductComponents = (product, isDisabled) => {
  const productDesc = (
    <SubmittedProductDescReview item={product} isDisabled={isDisabled} />
  )
  const pricingInfo = <PricingReview item={product} />
  const nutritionInfo = getNutritionInfo(product, isDisabled)
  const packagingInfo = getPackagingInfo(product, isDisabled)
  const imagesUpload = (
    <ImagesUploadReview item={product} isDisabled={isDisabled} />
  )
  const submitterInfo = <SubmitterInfo item={product} />
  const reviewStatus = <PendingProductStatus item={product} />
  const comments = <Comments item={product} />
  const reviewTwoFollowUp = (
    <ReviewTwoFollowUp item={product} isDisabled={isDisabled} />
  )
  return {
    productDesc,
    pricingInfo,
    imagesUpload,
    nutritionInfo,
    packagingInfo,
    submitterInfo,
    reviewStatus,
    comments,
    reviewTwoFollowUp,
  }
}

export const getReviewedProductComponents = product => {
  const productDesc = <ProductDescReview item={product} />
  const pricingInfo = <PricingReview item={product} />
  const nutritionInfo = getNutritionInfo(product, true)
  const packagingInfo = getPackagingInfo(product, true)
  const imagesUpload = <ImagesUploadReview item={product} isDisabled={true} />
  const submitterInfo = <SubmitterInfo item={product} />
  const reviewStatus = <ReviewedProductStatus item={product} />
  const comments = <Comments item={product} isDisabled={true} />
  const reviewTwoFollowUp = (
    <ReviewTwoFollowUp item={product} isDisabled={true} />
  )
  return {
    productDesc,
    pricingInfo,
    imagesUpload,
    nutritionInfo,
    packagingInfo,
    submitterInfo,
    reviewStatus,
    comments,
    reviewTwoFollowUp,
  }
}

export const psScrollToTop = () => {
  const elementX = Array.from(document.getElementsByClassName('ps__rail-x'))
  elementX.forEach(item => {
    console.log(item)
    item.style.bottom = '0px'
    item.style.left = '0px'
  })

  const elementY = Array.from(document.getElementsByClassName('ps__rail-y'))
  elementY.forEach(item => {
    console.log(item)
    item.style.top = '0px'
    item.style.right = '0px'
  })
}
